import { render, staticRenderFns } from "./ScanForTen.vue?vue&type=template&id=36972f77&scoped=true"
import script from "./ScanForTen.vue?vue&type=script&lang=js"
export * from "./ScanForTen.vue?vue&type=script&lang=js"
import style0 from "./ScanForTen.vue?vue&type=style&index=0&id=36972f77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36972f77",
  null
  
)

export default component.exports